import { render, staticRenderFns } from "./ReportConfigList.html?vue&type=template&id=15a48647&scoped=true&"
import script from "./ReportConfigList.vue?vue&type=script&lang=js&"
export * from "./ReportConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ReportConfigList.vue?vue&type=style&index=0&id=15a48647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a48647",
  null
  
)

export default component.exports